module.exports = __webpack_public_path__ + "static/media/dashboardDetails_en.dee34726.png";